export const LEAD_MARKETING2_REPORT1_REQUEST='LEAD_MARKETING2_REPORT1_REQUEST'
export const LEAD_MARKETING2_REPORT1_SUCCESS='LEAD_MARKETING2_REPORT1_SUCCESS'
export const LEAD_MARKETING2_REPORT1_FAIL='LEAD_MARKETING2_REPORT1_FAIL'

export const LEAD_MARKETING2_REPORT2_REQUEST='LEAD_MARKETING2_REPORT2_REQUEST'
export const LEAD_MARKETING2_REPORT2_SUCCESS='LEAD_MARKETING2_REPORT2_SUCCESS'
export const LEAD_MARKETING2_REPORT2_FAIL='LEAD_MARKETING2_REPORT2_FAIL'

export const LEAD_MARKETING2_REPORT3_REQUEST='LEAD_MARKETING2_REPORT3_REQUEST'
export const LEAD_MARKETING2_REPORT3_SUCCESS='LEAD_MARKETING2_REPORT3_SUCCESS'
export const LEAD_MARKETING2_REPORT3_FAIL='LEAD_MARKETING2_REPORT3_FAIL'

export const LEAD_MARKETING2_REPORT4_REQUEST='LEAD_MARKETING2_REPORT4_REQUEST'
export const LEAD_MARKETING2_REPORT4_SUCCESS='LEAD_MARKETING2_REPORT4_SUCCESS'
export const LEAD_MARKETING2_REPORT4_FAIL='LEAD_MARKETING2_REPORT4_FAIL'

export const LEAD_MARKETING2_REPORT5_REQUEST='LEAD_MARKETING2_REPORT5_REQUEST'
export const LEAD_MARKETING2_REPORT5_SUCCESS='LEAD_MARKETING2_REPORT5_SUCCESS'
export const LEAD_MARKETING2_REPORT5_FAIL='LEAD_MARKETING2_REPORT5_FAIL'
